<ul>
  @for (breadcrumb of (breadcrumbs$ | async); track $index; let first = $first; let last = $last) {
    <li class="breadcrumb-item">
      @if (!first) {
        <span> / </span>
      }
      <a [href]="breadcrumb.url" [ngClass]="{'latest': last}">{{ breadcrumb.label }}</a>
    </li>
  }
</ul>
